import { Routes } from '@angular/router';

export const integrationListRoutes: Routes = [
  {
    path: 'details',
    loadComponent: () =>
      import('../components/list/components/details-tool/details-tool.component').then(
        (m) => m.DetailsToolComponent
      )
  },
  {
    path: 'details/:id',
    loadComponent: () =>
      import('../components/list/components/details-tool/details-tool.component').then(
        (m) => m.DetailsToolComponent
      )
  },
  {
    path: 'configure/google-sheets',
    loadComponent: () =>
      import('../components/providers/components/google-sheets/google-sheets.component').then(
        (m) => m.GoogleSheetsComponent
      )
  },
  {
    path: 'configure/google-calendar',
    loadComponent: () =>
      import('../components/providers/components/google-calendar/google-calendar.component').then(
        (m) => m.GoogleCalendarComponent
      )
  },
  {
    path: 'configure/chat-gpt',
    loadComponent: () =>
      import('../components/providers/components/chat-gpt/chat-gpt.component').then(
        (m) => m.ChatGptComponent
      )
  },
  {
    path: 'configure/:slug',
    loadComponent: () =>
      import('../components/providers/providers.component').then(
        (m) => m.ProvidersComponent
      )
  },
  {
    path: '',
    redirectTo: 'list',
    pathMatch: 'full'
  }
];